import React, {PropTypes} from 'react';
import {Modal} from 'react-overlays';
import Button from '../../common/Button';
import '../../../styles/modals/apiTokenModal.css';

const ProfileApiTokenModal = ({modalShown, onHide, refreshAction}) => {

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 'auto',
    backgroundColor: '#000',
    opacity: 0.5
  };
  return (
    <Modal
      className="api-modal"
      backdropStyle={backdropStyle}
      show={modalShown}
      onHide={onHide}>
      <div className="api-modal-dialog">
        <div className="api-modal-text">
          <h3>Generate New Token</h3>
          <strong>Warning: generating a new token will automatically expire your current
            token. Are you sure want to do this? If so, you will need to update all the
            systems that use your current API token.</strong>
        </div>
        <div className="api-modal-buttons non-mobile">
          <Button
            onClick={refreshAction}
            className=" generate-new-token pull-right"
            value="YES, Generate New Token"
            disabled={false}/>
          <a className="btn btn-cancel pull-right" onClick={onHide}>
            No, Cancel
          </a>
        </div>
        <div className="api-modal-buttons mobile">
          <div className="api-modal-cancel">
            <a onClick={onHide}>
              Cancel
            </a>
          </div>
          <Button
            onClick={refreshAction}
            className="outlined-button generate-new-token pull-right"
            value="Generate New Token"
            disabled={false}/>
        </div>
      </div>
    </Modal>
  );
};
ProfileApiTokenModal.propTypes = {
  modalShown: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  refreshAction: PropTypes.func.isRequired
};

export default ProfileApiTokenModal;


/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileApiTokenModal.js
 **/